module.exports = __webpack_public_path__ + "img/ES03.300cb103.svg";